import { AppBar, TitlePortal, UserMenu } from 'react-admin';
import { Box, useMediaQuery, Theme, Typography, Avatar } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAdminContext } from '../utils/AdminContext';
import { Admin } from '../administration/type';
import { useErrorHandler } from '../utils/useErrorHandler';
import dataProvider from '../services/api';


const CustomAppBar = () => {
    const isLargeEnough = useMediaQuery<Theme>(theme => theme.breakpoints.up('sm'));
    const {avatarUrl, setAvatarUrl} = useAdminContext();
    const [admin, setAdmin] = useState<Admin | null>(null);
    const { handleErrorWithLogout } = useErrorHandler();

    useEffect(() => {
        const fetchAdminDetails = async () => {
        try {
            const response = await dataProvider.getAdminDetails('administration');
            const admin = response.data;
            setAdmin(admin)
            if (admin.profileImageUrl) {
            setAvatarUrl(admin.profileImageUrl);
            }
        } catch (error) {
            handleErrorWithLogout(error);
        }
        };
        fetchAdminDetails();
    }, [dataProvider, setAvatarUrl]);
    return (
        <AppBar
            color="secondary"
            sx={{
                background: 'linear-gradient(90deg, #B1B2B5 0%, #FFFFFF 3%, #2C4297 5%)',
                color: '#fff',
                '& .MuiSvgIcon-root': {
                    color: 'black', 
                },
            }}
        >
            {isLargeEnough && (
                <Box
                    component="img"
                    src="/logo_admin/logo.png" 
                    alt="Logo"
                    sx={{
                        height: '40px', 
                        marginLeft: '40px',
                    }}
                />
            )}
            <Typography variant="h6" color="inherit" sx={{ marginLeft: '10px' }}>
                Pakyaw Kalabaw Administration
            </Typography>
            {isLargeEnough && <Box component="span" sx={{ flex: 1 }} />}
            <UserMenu
                label={`${admin?.firstName}`+`${admin?.lastName}`}
                icon={
                <Avatar
                    src={avatarUrl || undefined}
                    alt={`${admin?.firstName}`+`${admin?.lastName}`}
                    sx={{ width: 32, height: 32 }}
                />
                }
            />
        </AppBar>
    );
};

export default CustomAppBar;